export default __webpack_public_path__ + "static/media/phone-call.bfc2714d.png";